import ApiManager from "./ApiManager";
import { AppCache } from "./myStorage";
import { AkeadSignature256 } from "./signature";
import { base64UrlToBase64, decodeBase64Utf8, encodeUtf8Base64 } from "./base64Utils";
import { AkdCrypt256b64, CryptoJSAesEncrypt } from "./cryp";
import config from "../config";

// const authenticationUrl = process.env.REACT_APP_API_URL;
const authenticationUrl = config().API_URL;
// const authenticationProdUrl = process.env.REACT_APP_AUTHENTICATION_PROD_URL;

export default class AuthenticationApi extends ApiManager {

  static async postResetPassword(params = {}) {
    try {
      const url = `${authenticationUrl}/Membership/renewPasswordMail/v2`;

      let body = {
        appCode: params.appCode || "200",
      };
      if (params.email) {
        body.email = params.email;
      }
      if (params.login) {
        body.login = params.login;
      }
      if (params.uuid) {
        body.uuid = params.uuid;
      }
      if (params.connectionCode) {
        body.connectionCode = params.connectionCode;
      }

      const signatureString = `${body?.email ?? ""}${body?.login ?? ""}${body?.uuid ?? ""}${body.appCode}`;
      const signature = CryptoJSAesEncrypt(signatureString);

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        consumer: "apidoc",
        "application-version": "1.0.0",
        signature
      };

      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error("API hatası: " + response.status);

      const jsonData = await response.json();

      return {
        success: jsonData.success,
        message: jsonData.message,
      };
    } catch (error) {
      console.error("postResetPassword error:", error);
      return {
        success: false,
        message: error.message || "İstek başarısız oldu.",
      };
    }
  }
}
